import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AngularFirestore } from "@angular/fire/firestore";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AngularFireStorage } from "@angular/fire/storage";
import { AngularFireFunctions } from "@angular/fire/functions";
import { AngularFireAuth } from "@angular/fire/auth/";
import { Router, ActivatedRoute } from "@angular/router";
import { UserPanelService } from "src/app/user-panel.service";
import { async } from "rxjs/internal/scheduler/async";
import { ClipsDialogComponent } from "src/app/clips-dialog/clips-dialog.component";
import { LoginDialogComponent } from "src/app/login-dialog/login-dialog.component";
import { LoadingDialogComponent } from "src/app/loading-dialog/loading-dialog.component";
import { StudyboxClipsDialogComponent } from "./studybox-clips-dialog/studybox-clips-dialog.component";
@Component({
  selector: "app-subjects",
  templateUrl: "./subjects.component.html",
  styleUrls: ["./subjects.component.scss"],
})
export class SubjectsComponent implements OnInit {
  subjects: any[];
  clips: any[];
  loggedInUser: any;
  tests: any[];
  constructor(
    private sanitizer: DomSanitizer,
    private firestore: AngularFirestore,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AngularFireAuth,
    private _snackBar: MatSnackBar,
    private storage: AngularFireStorage,
    private dialog: MatDialog,
    private fsFuncs: AngularFireFunctions,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    public zone: NgZone,
    private functions: AngularFireFunctions,
    private route: ActivatedRoute,
    private userPanelService: UserPanelService
  ) {
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true,
    });
    auth.onAuthStateChanged(async (userInfo) => {
      this.loggedInUser = userInfo;

      this.getUserTests()
        .then(() => {
          return this.getUserSubjects();
        })
        .then(() => dialogRef.close());
    });
  }

  ngOnInit(): void {}
  calculateUpgradePrice(subject, studyboxes) {
    console.log(subject, studyboxes);
    const wholeSubjectPrice = studyboxes.filter(
      (sb) => sb.studyboxName == "Ceo ispit (kompletna priprema)"
    )[0].studyboxPrice;
    const ownedStudyboxesPrice = subject.selectedStudyboxes.reduce(
      (sum, sb) => sum + sb.studyboxPrice,
      0
    );
    subject.upgradePrice = Math.max(
      0,
      wholeSubjectPrice - ownedStudyboxesPrice
    );
  }
  openYTVideos() {
    this.router.navigateByUrl("klipovi-youtube");
  }
  async openLoadingDialog(subjectName) {
    var width = "40%";
    if (window.outerWidth < 992) width = "80%";
    const dialogRef = this.dialog.open(LoadingDialogComponent, {
      width: width,
      disableClose: true,
      height: "90%",
      data: {},
      panelClass: "submitDialogStyle",
    });
    dialogRef.afterClosed().subscribe((result) => {});
    return dialogRef;
  }
  async openClipsDialog(subjectName) {
    var width = "40%";
    if (window.outerWidth < 992) width = "80%";
    var loadingDialog = this.openLoadingDialog(subjectName);
    var clips = await this.userPanelService.getClips(subjectName);
    (await loadingDialog).close();
    const dialogRef = this.dialog.open(ClipsDialogComponent, {
      width: width,
      height: "90%",
      data: {
        subjectName: subjectName,
        clips: clips,
      },
      panelClass: "submitDialogStyle",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }
  openStudyboxClipsDialog(studybox, subject) {
    let clips = [];
    let dialogRef = this.dialog.open(LoadingDialogComponent, {
      disableClose: true,
    });
    this.functions
      .httpsCallable("playback-getClipsForStudybox")({
        studybox: studybox,
      })
      .subscribe((response) => {
        this.zone.run(() => {
          let groups = [];
          console.log(response);
          let err = null;
          if (response.err) err = response.err;
          clips = response.clips;
          if (!err) {
            clips.forEach((c) => {
              c.clipNamePretty = c.clipName.replace(/_/g, " ").substring(8);
              c.groupId = /_([^_]*)$/gm
                .exec(c.groupId)[1]
                .replace(/([A-Z])/g, " $1")
                .replace(/^./, function (str) {
                  return str.toUpperCase();
                });
            });
            groups = this.groupBy(clips, "groupId");
          }
          this.dialog.open(StudyboxClipsDialogComponent, {
            data: {
              subject: subject,
              studybox: studybox,
              clips: groups,
              err: err,
            },
            maxHeight: "100vh",
          });
          dialogRef.close();
        });
      });
    console.log(studybox);
  }
  getUserTests() {
    return new Promise(async (resolve, reject) => {
      let instances = [];
      const testsSnap = await this.firestore
        .collection(`users/${this.loggedInUser.uid}/tests`)
        .get()
        .toPromise();
      this.tests = testsSnap.docs.map((ts) => ({ ...ts.data(), id: ts.id }));
      for (let test of this.tests) {
        const instancesSnap = await this.firestore
          .collection(
            `users/${this.loggedInUser.uid}/tests/${test.id}/instances`
          )
          .get()
          .toPromise();
        instances = instances.concat(
          instancesSnap.docs.map((is) => ({ id: is.id, ...is.data() }))
        );
      }
      this.tests = instances;
      console.log(instances);
      resolve(instances);
    });
  }
  getUserSubjects() {
    return new Promise(async (resolve, reject) => {
      const allStudyboxesSnap = await this.firestore
        .collection(`studyboxes`)
        .get()
        .toPromise();
      const allStudyboxes: any[] = allStudyboxesSnap.docs.map((sb) => {
        let studybox = sb.data();
        studybox.id = sb.id;
        return studybox;
      });
      var upgradeRequests = (
        await this.firestore
          .collection(`users/${this.loggedInUser.uid}/orders`)
          .get()
          .toPromise()
      ).docs.filter((o) => o.data().upgrade);
      var subjectUpgradeIDs = upgradeRequests.map(
        (snap) => snap.data().subject.id
      );
      this.firestore
        .collection(`users/${this.loggedInUser.uid}/subjects`)
        .get()
        .subscribe((data) => {
          this.subjects = data.docs.map((sub) => {
            var s = sub.data();
            s.id = sub.id;
            s.selectedStudyboxes =
              s.selectedStudyboxes != undefined ? s.selectedStudyboxes : [];
            s.selectedStudyboxes = s.selectedStudyboxes.sort(
              (a, b) => a.studyboxNum - b.studyboxNum
            );
            if (s.group == "FON")
              this.calculateUpgradePrice(
                s,
                allStudyboxes.filter((sb) => sb.subjectId == s.id)
              );
            const testsForThiSubject = this.tests.filter(
              (t) => t.subject.id === s.id
            );
            s.showSolutionsVideo = testsForThiSubject.reduce((show, t) => {
              console.log(t.submited);
              return t.submited == true ? true : show;
            }, false);
            console.log(s.showSolutionsVideo);
            return s;
          });
          resolve(true);
        });
    });
  }
  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
}
